function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "gfgh96nb4a",
  width: "164.3%",
  height: "201.1%",
  x: "-32.2%",
  y: "-50.5%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", null, React.createElement("g", {
  filter: "url(#gfgh96nb4a)",
  transform: "translate(-1091 -409) translate(1088 408)"
}, React.createElement("path", {
  fill: "#01A5E5",
  d: "M30.176 13.792l12.76 25.52c.711 1.423.135 3.153-1.288 3.864-.81.405-1.765.405-2.576 0L27.6 37.44l-11.472 5.736c-1.423.711-3.153.135-3.864-1.288-.405-.81-.405-1.765 0-2.576l12.76-25.52c.711-1.423 2.441-2 3.864-1.288.557.279 1.01.73 1.288 1.288z",
  transform: "rotate(-45 27.6 27.84)"
}), React.createElement("g", {
  fillRule: "nonzero",
  transform: "translate(48 42)"
}, React.createElement("rect", {
  width: 63,
  height: 28,
  x: .76,
  y: .12,
  fill: "#01A5E5",
  rx: 4.8
}), React.createElement("path", {
  fill: "#FFF",
  d: "M14.937 20.16l1.223-3.485h4.843l1.224 3.485h1.595l-4.49-12.175h-1.501L13.342 20.16h1.595zm5.62-4.776h-3.95l1.907-5.433h.135l1.907 5.433zm6.505 4.776V7.453h-1.451V20.16h1.451zm6.22.16c1.99 0 3.408-.962 3.83-2.514h-1.451c-.38.802-1.173 1.232-2.346 1.232-1.544 0-2.548-1.14-2.624-2.936v-.068h6.54v-.557c0-2.826-1.494-4.573-3.95-4.573-2.497 0-4.1 1.856-4.1 4.717 0 2.877 1.578 4.7 4.1 4.7zm2.421-5.459h-5.012c.11-1.611 1.122-2.674 2.574-2.674 1.442 0 2.404 1.063 2.438 2.674zm4.144 5.324l2.16-3.434h.135l2.151 3.434h1.721l-3.13-4.607 3.088-4.488h-1.645l-2.135 3.383h-.135l-2.16-3.383h-1.73l3.148 4.547-3.114 4.548h1.646z"
})))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 140,
    height: 90,
    viewBox: "0 0 140 90"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/alex-cursor.5ef0042e.svg";
export { SvgComponent as ReactComponent };